import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, PageEvent, Sort} from '@angular/material';
import {UserService} from '@services/user.service';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import {Observable} from 'rxjs/Rx';
import {RequestsHandler} from '@services/requests.service';
import {DialogSharedComponent} from '../dialog-shared/dialog-shared.component';
import {InitInformation} from "@models/init-information.interface";
import {ShipmentService} from "@services/shipment.service";
@Component({
  selector: 'registration-companies-dialog',
  templateUrl: './registration-companies.component.html'
})
export class RegistrationCompaniesDialog implements OnInit {
  companyRegistrationForm: FormGroup;
  progress = false;
  possibleCountries: Array<{value: string; label: string}>;
  openWindow(href) {
    window.open(href, '');
    return false;
  }
  constructor(
    private userService: UserService,
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<RegistrationCompaniesDialog>,
    public dialog: MatDialog,
    private handler: RequestsHandler,
    private shipmentService: ShipmentService,
    ) { }

  ngOnInit() {
    this.companyRegistrationForm = this._fb.group({
      user: this._fb.group({
        name: ['', Validators.required],
        surname: ['', Validators.required],
        email: ['', Validators.required],
        phone: [''],
        country_code: [''],
        zip: [''],
        city: [''],
        address: [''],
        company_name: ['', Validators.required],
        register_num: ['', Validators.required],
        invoice_country_code: ['', Validators.required],
        invoice_zip: ['', Validators.required],
        invoice_city: ['', Validators.required],
        invoice_address: ['', Validators.required],
        vat_number: ['', Validators.required]
      }),
    });
    this.shipmentService.getInitialData()
      .subscribe((data: InitInformation) =>
        this.possibleCountries = this.shipmentService.possibleCountries);
  }

  save() {
    this.progress = true;
    if (this.companyRegistrationForm.valid) {
      const controls = this.companyRegistrationForm.controls['user'];
      const data = {
        name:   controls['controls'].name.value,
        surname:   controls['controls'].surname.value,
        email:   controls['controls'].email.value,
        phone:   controls['controls'].phone.value,
        country_code: controls['controls'].country_code.value,
        zip:   controls['controls'].zip.value,
        city:   controls['controls'].city.value,
        address:   controls['controls'].address.value,
        company_name: controls['controls'].company_name.value,
        register_num: controls['controls'].register_num.value,
        invoice_country_code:   controls['controls'].invoice_country_code.value,
        invoice_zip: controls['controls'].invoice_zip.value,
        invoice_city: controls['controls'].invoice_city.value,
        invoice_address: controls['controls'].invoice_address.value,
        vat_number: controls['controls'].vat_number.value
      };

      this.userService.postCompany(data)
        .catch((error): any => {
          this.progress = false;
          if (error.error.hasOwnProperty('email')) {
            this.companyRegistrationForm.controls['user']['controls'].email.status = 'invalid';
          }
          this.handler.handleError(error);
          return Observable.throw(new Error(error));
        })
        .subscribe(() => {
          this.progress = false;
          this.dialogRef.close('Yes!');
        });
    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
    }
    return false;
  }
}

@Component({
  selector: 'companies-dialog',
  templateUrl: './dialog-companies.component.html'
})
export class CompanyDialog implements OnInit {
  companyDetails: any;
  userDetail = false;
  companyDetailsForm: FormGroup;
  progress = false;
  possibleCountries: Array<{value: string; label: string}>;

  constructor(private userService: UserService,
              private _fb: FormBuilder,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<CompanyDialog>,
              public shipmentService: ShipmentService) { }

  ngOnInit() {
    this.companyDetailsForm = this._fb.group({
      company: this._fb.group({
        name: [this.companyDetails.name, Validators.required],
        surname: [this.companyDetails.surname, Validators.required],
        email: [this.companyDetails.email, Validators.required],
        company: [this.companyDetails.company],
        phone: [this.companyDetails.phone],
        country_code: [this.companyDetails.country_code],
        zip: [this.companyDetails.zip],
        city: [this.companyDetails.city],
        address: [this.companyDetails.address],
        company_name: [this.companyDetails.company_name],
        register_num: [this.companyDetails.register_num],
        invoice_country_code: [this.companyDetails.invoice_country_code],
        invoice_zip: [this.companyDetails.invoice_zip],
        invoice_city: [this.companyDetails.invoice_city],
        invoice_address: [this.companyDetails.invoice_address],
        image: [this.companyDetails.image],
        vat_number: [this.companyDetails.vat_number],
        confirmed: [this.companyDetails.confirmed],
        confirmation_code: [this.companyDetails.confirmation_code],
        role: [this.companyDetails.role],
        status: [this.companyDetails.status],
        master_id: [this.companyDetails.master_id],
        logged_at: [this.companyDetails.logged_at],
        created_at: [this.companyDetails.created_at],
        updated_at: [this.companyDetails.updated_at],
        deleted_at: [this.companyDetails.deleted_at],
        id: [this.companyDetails.id],
        users: this._fb.array([
          ['']
        ])
      }),
    });
    this.loadCompleteDetails(this.companyDetails.id);
    this.shipmentService.getInitialData()
      .subscribe((data: InitInformation) =>
        this.possibleCountries = this.shipmentService.possibleCountries);
  }

  removeUser(id) {
    this.progress = true;
    this.userService.removeUser(id).subscribe((message) => {
      this.progress = false;
      if (message.message !== 'success') {
        const dialogRef = this.dialog.open(DialogSharedComponent,
          {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
      }
      this.dialogRef.close('Yes!');
    });
  }

  unsubscribeUser(id) {
    this.progress = true;
    this.userService.unassignUser(this.companyDetails.id, id).subscribe((message) => {
      this.progress = false;
      if (message.message !== 'success') {
        const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
      }
      this.dialogRef.close('Yes!');
    });
  }

  toggleDetail() {
    this.userDetail = !this.userDetail;
  }

  loadCompleteDetails(id) {
    this.userService.getCompleteDetails(id).subscribe((companyDetails) => {
      this.companyDetailsForm.controls['company']['controls'].name.setValue(companyDetails.name);
      this.companyDetailsForm.controls['company']['controls'].company_name.setValue(companyDetails.company_name);
      this.companyDetailsForm.controls['company']['controls'].register_num.setValue(companyDetails.register_num);
      this.companyDetailsForm.controls['company']['controls'].email.setValue(companyDetails.email);
      this.companyDetailsForm.controls['company']['controls'].phone.setValue(companyDetails.phone);
      this.companyDetailsForm.controls['company']['controls'].invoice_zip.setValue(companyDetails.invoice_zip);
      this.companyDetailsForm.controls['company']['controls'].invoice_address.setValue(companyDetails.invoice_address);
      this.companyDetailsForm.controls['company']['controls'].invoice_city.setValue(companyDetails.invoice_city);
      this.companyDetailsForm.controls['company']['controls'].invoice_country_code.setValue(companyDetails.invoice_country_code);
      for (const j in companyDetails.users) {
        (<FormArray>this.companyDetailsForm.controls['company']['controls'].users).push(new FormControl(companyDetails.users[j]));
      }
      this.companyDetailsForm.controls['company']['controls'].logged_at.setValue(companyDetails.logged_at);
      this.companyDetailsForm.controls['company']['controls'].country_code.setValue(companyDetails.country_code);
      this.companyDetailsForm.controls['company']['controls'].id.setValue(companyDetails.id);
      this.companyDetailsForm.controls['company']['controls'].role.setValue(companyDetails.role);
      this.companyDetailsForm.controls['company']['controls'].status.setValue(companyDetails.status);
      this.companyDetailsForm.controls['company']['controls'].surname.setValue(companyDetails.surname);
      this.companyDetailsForm.controls['company']['controls'].zip.setValue(companyDetails.zip);
      this.companyDetailsForm.controls['company']['controls'].vat_number.setValue(companyDetails.vat_number);
    });
  }

  save() {
    this.progress = true;
    if (this.companyDetailsForm.valid) {
      const controls = this.companyDetailsForm.controls['company'];
      const data = {
        name:   controls['controls'].name.value,
        surname:   controls['controls'].surname.value,
        email:   controls['controls'].email.value,
        phone:   controls['controls'].phone.value,
        company:   controls['controls'].company.value,
        company_name: controls['controls'].company_name.value,
        register_num: controls['controls'].register_num.value,
        invoice_country_code: controls['controls'].invoice_country_code.value,
        invoice_zip: controls['controls'].invoice_zip.value,
        invoice_city: controls['controls'].invoice_city.value,
        invoice_address: controls['controls'].invoice_address.value,
        id:   controls['controls'].id.value,
        confirmed:   controls['controls'].confirmed.value,
        role:   controls['controls'].role.value,
        status:   controls['controls'].status.value,
        master_id:   controls['controls'].master_id.value,
        logged_at:   controls['controls'].logged_at.value,
        vat_number:   controls['controls'].vat_number.value,
        same_as_invoice_address: 1,
      };

      this.userService.setCompany(data).subscribe((message) => {
        this.progress = false;
        this.dialogRef.close('Yes!');
        if (message.message !== 'success') {
          const dialogRef = this.dialog.open(DialogSharedComponent,
            {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
        }
      }, (error): any => {
        this.progress = false;
        return Observable.throw('Internal server error');
      });
    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
    }
    return false;
  }
}

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {
  progress = false;
  companies;
  logged = false;
  sortedData;
  length;
  pageSize;
  pageIndex;
  pageSizeOptions = [5, 10, 25, 50];
  filterValue = '';
  sort = '';
  order = '';

  constructor( private userService: UserService, public dialog: MatDialog) {
  }

  ngOnInit() {
    this.getCompanies({pageIndex: 0, pageSize: '50'});
  }

   getCompanies(page) {
     this.progress = true;
    const params =  {page : page.pageIndex + 1 ,
      size: page.pageSize,
      filter: page.hasOwnProperty('filterValue') ? page.filterValue : this.filterValue,
      sort: page.hasOwnProperty('sort') ? page.sort : this.sort,
      order: page.hasOwnProperty('order') ? page.order : this.order};
    this.userService.getCompanies(params).subscribe((companies) => {
      this.companies = companies.data;
      this.length = companies.total;
      this.pageSize = companies.per_page;
      this.pageIndex = companies.current_page;
      this.sortedData = this.companies.slice();
      this.logged = true;
      this.progress = false;
    });
  }

  openEditDialog(user) {
    const dialogRef = this.dialog.open(CompanyDialog, {width: '680px'});
    dialogRef.componentInstance.companyDetails = user;
    dialogRef.afterClosed().subscribe(result => {
      this.getCompanies({pageIndex: 0, pageSize: this.pageSize});
    });
  }

  regitsrationCompany() {
    const dialogRef = this.dialog.open(RegistrationCompaniesDialog, {width: '680px'});
    dialogRef.afterClosed().subscribe(result => {
      this.getCompanies({pageIndex: 0, pageSize: this.pageSize});
    });
  }

  removeCompany(user) {
    const dialogRef = this.dialog.open(DialogSharedComponent,
      {width: '450px', data: { id: user.name, bodyModalText: 'company.remove' }});
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'true') {
        this.progress = true;
        this.userService.removeCompany(user.id).subscribe((message) => {
          if (message.message === 'success') {
            this.getCompanies({pageIndex: 0, pageSize: this.pageSize});
          }
        }, (error): any => {
          this.progress = false;
          return Observable.throw('Internal server error');
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.getCompanies({pageIndex: 0, pageSize: this.pageSize, filterValue: filterValue});
    this.filterValue = filterValue;
    this.pageIndex = 0;
  }
  sortData(sort: Sort) {
    this.getCompanies({pageIndex: 0, pageSize: this.pageSize, sort: sort.active, order: sort.direction});
    this.sort = sort.active;
    this.order = sort.direction;

  }
}



// WEBPACK FOOTER //
// ./src/app/components/companies/companies.component.ts